import { Badge, Chip } from '@mui/material';

/** 미배분 라인 수를 배지로 보여주고, 누르면 그 라인만 걸러 보게 한다. 0이면 조용히 사라진다. */
export default function UnallocatedAlert({ count, active, onToggle }) {
    if (!count) return <Chip size="small" label="All lines allocated" sx={{ bgcolor: '#2e7d32', color: 'white', fontSize: 11, height: 22 }} />;
    return (
        <Badge badgeContent={count} color="error">
            <Chip size="small" label="Unallocated lines" onClick={onToggle} variant={active ? 'filled' : 'outlined'} color="warning" sx={{ fontSize: 11, height: 22, cursor: 'pointer' }} />
        </Badge>
    );
}
